const PWA_BANNER_DISMISS_KEY = 'foco_pwa_banner_dismissed';
const PWA_POST_LOGIN_KEY = 'foco_pwa_post_login';
const DISMISS_DAYS = 14;

export type MobilePlatform = 'ios' | 'android' | 'other';

export function isStandalonePwa(): boolean {
  if (typeof window === 'undefined') return false;
  const mq = window.matchMedia('(display-mode: standalone)').matches;
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true;
  return mq || iosStandalone;
}

export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const mobileUa = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const narrow = window.matchMedia('(max-width: 768px)').matches;
  const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  return mobileUa || (narrow && touch);
}

export function getMobilePlatform(): MobilePlatform {
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'other';
}

function isDismissedWithinDays(key: string): boolean {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return false;
    const dismissedAt = Number(raw);
    if (Number.isNaN(dismissedAt)) return false;
    const ms = DISMISS_DAYS * 24 * 60 * 60 * 1000;
    return Date.now() - dismissedAt < ms;
  } catch {
    return false;
  }
}

export function isPwaBannerDismissed(): boolean {
  return isDismissedWithinDays(PWA_BANNER_DISMISS_KEY);
}

export function dismissPwaBanner(): void {
  try {
    localStorage.setItem(PWA_BANNER_DISMISS_KEY, String(Date.now()));
    sessionStorage.removeItem(PWA_POST_LOGIN_KEY);
  } catch {
    /* ignore */
  }
}

export function markPwaHighlightAfterLogin(): void {
  if (!isMobileDevice() || isStandalonePwa()) return;
  try {
    sessionStorage.setItem(PWA_POST_LOGIN_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function isPwaHighlightAfterLogin(): boolean {
  try {
    return sessionStorage.getItem(PWA_POST_LOGIN_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearPwaHighlightAfterLogin(): void {
  try {
    sessionStorage.removeItem(PWA_POST_LOGIN_KEY);
  } catch {
    /* ignore */
  }
}

export function shouldOfferPwaInstall(): boolean {
  return isMobileDevice() && !isStandalonePwa();
}

export function shouldShowPwaBanner(): boolean {
  return shouldOfferPwaInstall() && !isPwaBannerDismissed();
}
